import React from "react";

const JobTitlesTable = ({ groupedByJobTitle, onDelete }) => (
  <div style={{ maxHeight: "400px", overflowY: "auto" , zIndex: "99"}}>
    <table className="table table-bordered table-sm mb-0">
      <thead className="table-light">
        <tr>
          <th style={{ width: "30%" }}>Job Title</th>
          <th style={{ width: "60%" }}>Employees</th>
          <th style={{ width: "10%" }}>Action</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(groupedByJobTitle).length > 0 ? (
          Object.entries(groupedByJobTitle).map(([jobTitleId, { label, employees }]) => {
            const formatted = employees.map(
              (emp) => `${emp.employee_name} (${emp.employee_id})`
            );

            return (
              <tr key={jobTitleId} style={{ verticalAlign: "top" }}>
                <td className="fw-semibold">{label}</td>
                <td>
                  {formatted.length > 0 ? (
                    <span>{formatted.join(", ")}</span>
                  ) : (
                    <span className="text-muted">—</span>
                  )}
                </td>
                <td className="text-center">
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => onDelete(Number(jobTitleId))}
                    title="Delete this job title"
                    //disabled= "true"
                  >
                    <i className="bx bxs-trash" />
                  </button>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={3} className="text-muted text-center py-3">
              No job titles found for this group.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default JobTitlesTable;